import { CustomTooltipProps } from '@ag-grid-community/react';
import { OTIFTags } from '../../../Common/Enum';
import { tag, textWrapper } from './TagCellRenderer/styles.css';

export default (props: CustomTooltipProps & { color: string }) => {

    const allTags = OTIFTags[props.value].split('_');
    const tags: string[] = [];
    console.log(allTags);
    if(allTags[1] === 'False'){
        tags.push('ot');
    }
    if(allTags[3] === 'False'){
        tags.push('if');
    }

    console.log(tags, 'ENUM')

    return (
        <div className="custom-tooltip">
            {tags.length > 0 && <div className={textWrapper}>
                {tags?.map((s, index) => {
                    return (
                        <div className={tag}
                        style={{
                            background: `${s === "if" ? "#FEA236" : "#D1750C"}`,
                        }}
                        key={`${index + s}`}
                        >
                        {s === "if" ? "IF Failed" : "OT Failed"}
                        </div>
                    );
                })}
            </div>}
        </div>
    );
};
